import { TranslateService } from '@ngx-translate/core';

export const getGoogleAuthError = (error: any, translateService: TranslateService) => {
  if (typeof error === 'string') {
    return error;
  }
  
  return translateService.instant('auth_errors.google_auth_unsuccessful');
};
